import { init, track } from '@amplitude/analytics-browser';
import { datadogRum } from '@datadog/browser-rum';

const DEV_MODE = import.meta.env.DEV;

/**
 * Initialize Amplitude with the provided user ID
 *
 * @param {string} userId - the user ID
 */
export function initialize(userId) {
  if (DEV_MODE) {
    return;
  }
  try {
    init(import.meta.env.UF_AMPLITUDE_API_KEY, userId, {
      serverUrl: import.meta.env.UF_AMPLITUDE_API_ENDPOINT,
    });
  } catch (error) {
    datadogRum.addError(`Failed to initialize Amplitude: ${error}`);
  }
}

/**
 * Track an event with Amplitude
 *
 * @param {string} eventType - the event type
 * @param {object} eventProperties - the event properties
 */
export function trackEvent(eventType, eventProperties) {
  if (DEV_MODE) {
    return;
  }
  track(eventType, eventProperties);
}
